//
// # PlatformTransport Interface
//
// The minimal wire protocol for sending and receiving messages between
// Editor and its host environment. This is the raw transport layer -
// WebSocket, postMessage, or any other message-passing mechanism.
//
// Platform implementations (e.g. Web) create PlatformTransport instances
// and wrap them in MessagePlatform to get the rich Platform interface.
//

import { msgs } from "CoreUtils";

// The minimal transport interface - just send/receive.
export interface PlatformTransport {
  // Transport name. For printing & debugging purposes only.
  readonly name: string;

  // Send a message to the host.
  send(msg: msgs.ToPlatform): void;

  // Register a function to handle incoming messages from the host.
  onMessage(handler: msgs.Handler): void;
}

export const PlatformTransport = {
  // A dummy "null PlatformTransport".
  // Does nothing. Useful during startup before a real transport is available.
  Null: {
    name: "NullTransport",
    send: (_: msgs.ToPlatform) => {},
    onMessage: (_: msgs.Handler) => {},
  } satisfies PlatformTransport,
};
